export const AlertIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        d="M24.0007 13.2102L38.7469 38.6881H9.2544L24.0007 13.2102ZM24.0007 5.39648L2.45898 42.6048H45.5423L24.0007 5.39648Z"
        fill="#004A80"
      />
      <path
        d="M25.959 32.8132H22.0423V36.7298H25.959V32.8132Z"
        fill="#004A80"
      />
      <path
        d="M25.959 21.0632H22.0423V30.8548H25.959V21.0632Z"
        fill="#004A80"
      />
    </svg>
  );
};
